/**
 * Κοινές προεπιλογές πλατφορμών για την οθόνη του καταστήματος (PlatformIntegration) και το support (25/10/2026).
 * Το efood δουλεύει με ΕΝΑ λογαριασμό integrator σε όλη την αλυσίδα — προσυμπληρώνεται, ώστε σε νέο κατάστημα να
 * χρειάζεται μόνο το vendor id. Ως τις 25/10/2026 ήταν γραμμένος δύο φορές μέσα στο PlatformIntegration.tsx.
 */
export const EFOOD_INTEGRATOR = {
  username: 'xentrix',
  password: 'X3ntrix2525!!',
};
